import axios from "../../../helper/axios";
import * as actionTypes from "../actionTypes";

// fetch projects
export const fetchProjectsForMilestonStart = () => {
  return {
    type: actionTypes.FETCH_USER_PROJECTS_FOR_MILESTONE_START,
  };
};

export const fetchProjectsForMilestonSuccess = (projects) => {
  return {
    type: actionTypes.FETCH_USER_PROJECTS_FOR_MILESTONE_SUCCESS,
    projects,
  };
};

export const fetchProjectsForMilestonFail = (error) => {
  return {
    type: actionTypes.FETCH_USER_PROJECTS_FOR_MILESTONE_FAIL,
    error,
  };
};

export const fetchAllProjects = () => {
  return (dispatch) => {
    dispatch(fetchProjectsForMilestonStart());
    axios
      .get(`client/project`)
      .then((res) => {
        // console.log(res);

        dispatch(fetchProjectsForMilestonSuccess(res.data.projects));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchProjectsForMilestonFail(err.response.data.message));
        } else {
          dispatch(fetchProjectsForMilestonFail("Something went wrong"));
        }
      });
  };
};

// select project from update section
export const MilestonePrecentUser = (calc) => {
  return {
    type: actionTypes.USER_MILESTONE_PERCENT,
    calc,
  };
};

// fetch milestons
export const fetchMilestonesStart = () => {
  return {
    type: actionTypes.FETCH_USER_MILESTONES_START,
  };
};

export const fetchMilestonesSuccess = (
  milestones,
  count,
  totalOfDone,
  percentage
) => {
  return {
    type: actionTypes.FETCH_USER_MILESTONES_SUCCESS,
    milestones,
    count,
    totalOfDone,
    percentage,
  };
};

export const fetchMilestonesFail = (error) => {
  return {
    type: actionTypes.FETCH_USER_MILESTONES_FAIL,
    error,
  };
};

export const fetchMilestones = (projectId, pageN, pageS) => {
  return (dispatch) => {
    dispatch(fetchMilestonesStart());
    axios
      .get(
        `client/task/${projectId}?pageNumber=${pageN}&pageSize=${pageS}`
      )
      .then((res) => {
        console.log(res);
        dispatch(
          fetchMilestonesSuccess(
            res.data.tasks,
            res.data.total,
            res.data.totalDone,
            Math.floor((res.data.totalDone / res.data.total) * 100)
          )
        );
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchMilestonesFail(err.response.data.message));
        } else {
          dispatch(fetchMilestonesFail("Something went wrong"));
        }
      });
  };
};

export const clearMilestoneMsg = () => {
  return {
    type: actionTypes.CLEAR_USER_MSG_MILESTONE,
  };
};
